// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import EyeOutlinedSvg from "@ant-design/icons-svg/lib/asn/EyeOutlined";
import AntdIcon from "../components/AntdIcon";
const EyeOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: EyeOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    EyeOutlined.displayName = "EyeOutlined";
}
export default /*#__PURE__*/ React.forwardRef(EyeOutlined);
